const config = require('./config');

/**
 * Returns the merged config for a specific environment and app.
 * @param {'LOCAL'|'DEV'|'PROD'} env
 * @param {string} app - app key e.g. 'recruiter-dashboard'
 */
function getConfig(env, app) {
    const envData = config[env] ?? config.LOCAL;
    const appConfig = envData.appConfigs[app];
    if (!appConfig) throw new Error(`Unknown app '${app}'.`);
    return { ...appConfig, storage: envData.storage };
}

/**
 * Returns only the storage config for a specific environment.
 * Used by server-configmap to inject fileStorage without needing an app key.
 * @param {'LOCAL'|'DEV'|'PROD'} env
 */
function getStorageConfig(env) {
    const envData = config[env] ?? config.LOCAL;
    return envData.storage;
}

module.exports = { getConfig, getStorageConfig };
